import { useOptimisticMutation } from "../hooks/useOptimisticMutation";
import { upsertBettingSelectionsSuspensions } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import type {
  UpsertBettingSelectionSuspensionsParams,
  BettingSelectionSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingSelection";

export const useUpsertBettingSelectionsSuspensions = (
  bettingMarketId?: number,
  targetUsername?: string
) => {
  const queryKey = [BettingSelectionsQueryKeys.BettingSelectionsSuspensions, bettingMarketId, targetUsername];

  return useOptimisticMutation<
    UpsertBettingSelectionSuspensionsParams,
    BettingSelectionSuspensionsEditorResponse
  >({
    queryKey,
    mutationFn: upsertBettingSelectionsSuspensions,
    optimisticUpdate: (variable, oldData) => {
      if (!oldData) return oldData;

      const newSuspensions = { ...oldData.suspensions };
      for (const s of variable.suspensions) {
        newSuspensions[s.bettingSelectionId] = { id: s.bettingSelectionId, active: s.active };
      }

      return { ...oldData, suspensions: newSuspensions };
    },
    updateOptions: { exactQueryKey: true },
  });
};
